import apiClient from '../../api/apiClient';

export async function register(email, password) {
	const response = await apiClient.post('/auth/register', { email, password }, { _skipAuth: true });
	return response.data;
}

export async function login(email, password) {
	const response = await apiClient.post('/auth/login', { email, password }, { _skipAuth: true });
	return response.data;
}

export async function loginWithGoogle(idToken) {
	const response = await apiClient.post('/auth/google', { idToken }, { _skipAuth: true });
	return response.data;
}

export async function refreshTokens(refreshToken) {
	const response = await apiClient.post('/auth/refresh', { refreshToken }, { _skipAuth: true });
	return response.data;
}

export async function logout(refreshToken) {
	const response = await apiClient.post('/auth/logout', { refreshToken });
	return response.data;
}

export async function getUser() {
	const response = await apiClient.get('/user/get-user');
	return response.data;
}

export async function confirmEmail(token) {
	const response = await apiClient.post('/auth/confirm-email', { token }, { _skipAuth: true });
	return response.data;
}

export async function resendConfirmation(email) {
	const response = await apiClient.post('/auth/resend-confirmation', { email }, { _skipAuth: true });
	return response.data;
}

export async function forgotPassword(email) {
	const response = await apiClient.post('/auth/forgot-password', { email }, { _skipAuth: true });
	return response.data;
}

export async function resetPassword(token, newPassword) {
	const response = await apiClient.post('/auth/reset-password', { token, newPassword }, { _skipAuth: true });
	return response.data;
}

export async function updateProgrammingLanguage(programmingLanguage) {
	const response = await apiClient.put('/user/programming-language', { programmingLanguage });
	return response.data;
}
